import { http } from '@/plugins/http';

// eslint-disable-next-line import/prefer-default-export
export async function findLogs() {
  const response = await http.get('/mxmed/webhook/logs');
  return response.data;
}
